import send from "../../util/request";

// 询价清单-列表
export const enquiryListSelect = (params) => send({ url: '/ipp/enquiry/list-select', method: 'POST', data: params, options: { loading: true } });

// 询价清单-删除
export const enquiryListDelete = (params) => send({ url: '/ipp/enquiry/list-delete', method: 'POST', data: params, options: { loading: false } });

// 询价清单-新增/编辑
export const enquiryListSave = (params) => send({ url: '/ipp/enquiry/list-save', method: 'POST', data: params, options: { loading: false } });

// 询价商品列表
export const enquiryProducts = (params) => send({ url: '/ipp/enquiry/products', method: 'POST', data: params, options: { loading: false } });

// 询价单-创建
export const enquiryCreateOrder = (params) => send({ url: '/ipp/enquiry/create-order', method: 'POST', data: params, options: { loading: false } });

// 询价单-列表
export const enquiryOrders = (params) => send({ url: '/ipp/enquiry/orders', method: 'POST', data: params, options: { loading: false } });
// 询价单-详情

export const enquiryOrder = (params) => send({ url: '/ipp/enquiry/order', method: 'POST', data: params, options: { loading: false } });

//询价单-创建采购单

export const enquiryPurchase = (params) => send({ url: '/ipp/enquiry/purchase', method: 'POST', data: params, options: { loading: false } });
